import styled from "styled-components";

import linePortrait from "../../assets/svg/linePortrait.svg";

import theme from "../../styles/theme";

export const Container = styled.div`
  @keyframes opacityIn {
    0% {
      opacity: 0;
    }

    50% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  @keyframes slidein {
    0% {
      width: 0%;
      opacity: 0;
    }

    50% {
      width: 0%;
      opacity: 0;
    }

    100% {
      width: 100%;
      opacity: 1;
    }
  }

  @media (orientation: landscape) {
    div {
      width: 100%;
      height: 100%;
      position: absolute;
      display: flex;
      align-items: center;
    }
    .title-content {
      display: flex;
      color: white;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: flex-start;
      height: 100%;
      background: none;
      align-self: baseline;
      width: 55%;

      @media screen and (max-width: 1162px) {
        width: 54%;
      }
      @media screen and (min-width: 1192px) {
        width: 40%;
      }
      @media screen and (min-width: 1177px) {
        width: 33%;
        padding-left: 100px;
      }
      @media screen and (min-width: 1587px) {
        width: 30%;
        padding-left: 120px;
      }
      @media screen and (min-width: 1587px) {
        ${"" /* width: 20%; */}
        padding-left: 170px;
      }
      @media screen and (min-width: 2632px) {
        width: 18%;
        padding-left: 130px;
      }
      @media screen and (min-width: 1366px) {
        width: 18%;
        padding-left: 160px;
      }
    }

    h1 {
      color: ${theme.textYellow};
      text-transform: uppercase;
      ${"" /* font-size: 6rem; */}
      width: min-content;
      line-height: 131px;
      white-space: nowrap;
      position: absolute;
      top: 14%;
      left: 42px;
      width: 480px;
      font-size: 110px;

      :last-of-type {
        top: calc(14% + 120px);
        left: 100px;
      }

      @media (min-width: 1366px) {
        top: 17%;
        width: 670px;
        font-size: 140px;

        :last-of-type {
          top: calc(17% + 150px);
          left: 131px;
        }
      }
    }

    p {
      color: ${theme.white};
      line-height: 75px;
      font-weight: bold;
      position: absolute;
      top: calc(14% + 270px);
      left: 100px;
      width: 450px;
      font-size: 50px;
      
      @media (min-width: 1366px) {
        top: calc(17% + 330px);
        left: 131px;
        font-size: 70px;
        line-height: 100px;
        width: 580px;
      }
    }
    
    .line-carousel {
      height: 75%;
      position: absolute;
      bottom: 0;

    .first {
      border-top: 5px solid white;
      width: 5%;
      height: inherit;
    }

    .second {
      width: 95%;
      border-bottom: 5px solid white;
      height: inherit;
      border-left: 5px solid white;
    }
  }
  }
    
  @media (orientation: portrait) {
    div {
      bottom: 0px;
      width: 100%;
      height: 45%;
      position: absolute;
    }

    .title-content {
      bottom: 80px;
      left: 17%;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      height: 40%;
    }

    h1 {
      color: ${theme.textYellow};
      text-transform: uppercase;
      bottom: 447px;
      width: 400px;
      font-size: 5rem;
      line-height: 117px;
      margin-bottom: 40px;

      position: absolute;
      top: 11%;
      left: -80px;

      :last-of-type{
        top: calc(11% + 80px);
        left: 0px;
      }
      
      @media screen and (min-width: 768px) {
        font-size: 4rem;
        bottom: 300px !important;
      }
      
      @media screen and (min-width: 1024px) {
        font-size: 5rem;
        top: 13%;
        left: -120px;
        width: 400px;

        :last-of-type{
          top: calc(13% + 90px);
          left: 0px;
        }
      }
    }

    p {
      color: ${theme.white};
      line-height: 80px;
      width: 50%;
      font-size: 4rem;
      font-weight: bold;

      position: absolute;
      top: calc(11% + 200px);
      left: 0px;

      @media screen and (min-width: 768px) {
        font-size: 2rem;
        line-height: 50px;
        width: 60% !important;
      }
      
      @media screen and (min-width: 1024px) {
        font-size: 3rem;
        line-height: 70px;
        width: 50%;

        top: calc(13% + 220px);
      }
    }

    .line-carousel {
      background-image: url(${linePortrait});
      height: 24vh;
      bottom: 80px;
      background-repeat: no-repeat;
      background-size: cover;
  }
`;
